import { Injectable, signal } from '@angular/core';

export type ConfirmTone = 'default' | 'warning' | 'danger';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: ConfirmTone;
}

interface ConfirmDialogState extends Required<Omit<ConfirmDialogOptions, 'tone'>> {
  tone: ConfirmTone;
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private resolver: ((confirmed: boolean) => void) | null = null;
  private readonly stateSignal = signal<ConfirmDialogState | null>(null);

  readonly state = this.stateSignal.asReadonly();

  confirm(options: ConfirmDialogOptions): Promise<boolean> {
    // Une nouvelle demande ferme proprement l'ancienne pour éviter deux modales concurrentes.
    this.resolve(false);
    this.stateSignal.set({
      title: options.title,
      message: options.message,
      confirmLabel: options.confirmLabel ?? 'Confirmer',
      cancelLabel: options.cancelLabel ?? 'Annuler',
      tone: options.tone ?? 'default',
    });

    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  accept(): void { this.resolve(true); }
  cancel(): void { this.resolve(false); }

  private resolve(value: boolean): void {
    const resolver = this.resolver;
    this.resolver = null;
    this.stateSignal.set(null);
    resolver?.(value);
  }
}
